/**
 * Open modal for filters
 */

import { setFocusTrap , removeFocusTrap } from "./focusTrap.js";

const body = document.body;
const closeButton = Array.from(document.getElementsByClassName('js-search-filters-close'));
const openButton = document.querySelector('.js-button-filters');
const filtersModal = document.querySelector('.search-filters');
if(filtersModal) {
  // first element seems to be ignored by focus, so the second is ok
  const firstFocusableElement = filtersModal.querySelector(".js-search-filters-close");
  // const firstFocusableElement = filtersModal.querySelector("[tabindex='0']");
}

function closeFilters() {
  filtersModal.classList.remove('search-filters--open');
  body.classList.remove('filters-open');
  filtersModal.setAttribute('aria-hidden', 'true');
  removeFocusTrap(filtersModal);
}

function openFilters() {
  filtersModal.classList.add('search-filters--open');
  body.classList.add('filters-open');
  setFocusTrap(filtersModal);
  filtersModal.setAttribute('aria-hidden', 'false');
  //firstFocusableElement.focus(); // commenté par Pierre car génère une erreur js
}

if (closeButton) {
  closeButton.forEach((item) => {
    item.addEventListener('click',() =>  {
      closeFilters();
    });
  });
}

if (openButton) {
  openButton.addEventListener('click',() =>  {
    openFilters();
  });
}

window.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && document.body.classList.contains('filters-open')) {
    closeFilters();
  }
})
